import {useEffect, useState} from 'react';

const getSize = () => ({
  width: window.visualViewport?.width || window.innerWidth,
  height: window.visualViewport?.height || window.innerHeight
});

const useFixedWindowSize = () => {
  const [size, setSize] = useState(getSize());

  useEffect(() => {
    const updateSize = () => setSize(getSize());

    window.visualViewport?.addEventListener('resize', updateSize);
    window.visualViewport?.addEventListener('scroll', updateSize); // For soft keyboard cases

    window.addEventListener('orientationchange', () => {
      // Wait a bit after orientation change before updating size
      setTimeout(updateSize, 200);
    });

    return () => {
      window.visualViewport?.removeEventListener('resize', updateSize);
      window.visualViewport?.removeEventListener('scroll', updateSize);
    };
  }, []);

  return size;
};

export default useFixedWindowSize;
